import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  rateCalculationTimeout: {
    description: 'Error message when rate calculation times out',
    defaultMessage: 'Rate calculation timed out - please try again',
    id: 'poN6Pf',
  },
  noRateDataFound: {
    description: 'Error message when no rate data is found for the order',
    defaultMessage: 'No rate data found for this order',
    id: 'qQVg5q',
  },
  failedToInitiateRating: {
    description: 'Error message when bulk rating fails to initiate',
    defaultMessage: 'Failed to initiate rating',
    id: 'fMwuts',
  },
  failedToSaveConfiguration: {
    description: 'Error message when configuration save fails',
    defaultMessage: 'Failed to save configuration',
    id: '/coZ2a',
  },
});
